import RESTAPIConfig from "@/config/RESTAPIConfig";
import { TagTypesInterface } from "@/store/ApiSlice";

const restApiConfig = new RESTAPIConfig();

export function buildReferenceBookUrl(path: string): string {
    return restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + path;
}

export function createInvalidateTagsOnSuccess(tags: TagTypesInterface | TagTypesInterface[]) {
    const tagsArray = Array.isArray(tags) ? tags : [tags];

    return (_result: unknown, error: unknown) => {
        if (error) return [];
        return tagsArray;
    };
}

export function createProvideTags(tag: TagTypesInterface) {
    return [{ type: tag, id: "ALL" }, "FetchedData" as const];
}

export function createMutationQuery(url: string, method: "POST" | "PUT") {
    return (body: unknown) => ({
        url: buildReferenceBookUrl(url),
        method,
        body,
    });
}

export function createDeleteQuery(url: string) {
    return (id: number | string) => ({
        url: buildReferenceBookUrl(url),
        method: "DELETE" as const,
        params: { id },
    });
}

export function createListQuery<T extends object = object>(url: string) {
    return (params?: T | void) => {
        if (!params || typeof params !== "object") {
            return {
                url: buildReferenceBookUrl(url),
            };
        }

        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((item) => {
                    if (item !== null && item !== undefined) {
                        searchParams.append(`${key}[]`, String(item));
                    }
                });
            } else if (typeof value === "boolean") {
                searchParams.append(key, value ? "1" : "0");
            } else if (value !== null && value !== undefined) {
                searchParams.append(key, String(value));
            }
        });

        return {
            url: buildReferenceBookUrl(url),
            params: searchParams,
        };
    };
}
